export default {"src":"/_next/static/media/icon-level-10.33e9c039.svg","height":30,"width":63};